export default __webpack_public_path__ + "assets/images/0ab47a3d836b0769026a27e0401a238e.png";